export default __webpack_public_path__ + "static/media/lock-open-with-margin.06c94ed0.svg";